import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-long-down-right', 'ArrowLongDownRight', [["path",{"d":"M13 19h6v-6m0 6L5 5","key":"svg-0"}]]);